import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=54bcf504"
import script from "./Routes.vue?vue&type=script&lang=js"
export * from "./Routes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54bcf504')) {
      api.createRecord('54bcf504', component.options)
    } else {
      api.reload('54bcf504', component.options)
    }
    module.hot.accept("./Routes.vue?vue&type=template&id=54bcf504", function () {
      api.rerender('54bcf504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Routes.vue"
export default component.exports